import { render } from "./imgCarousel.vue?vue&type=template&id=b74c137c"
import script from "./imgCarousel.vue?vue&type=script&lang=js"
export * from "./imgCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__